module.exports = __webpack_public_path__ + "static/img/zhaoshang.7ec8299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhaoshang.png
// module id = bSnf
// module chunks = 1